import { report } from '../middleware/report';
import { getReportParams } from '../middleware/report';
import EpiContext from '@episerver/spa-core/Spa';



const createDwhAction = (dictValue: any) => {
  const actionObj: any = {};

    
    Object.keys(dictValue.options).forEach(optionKey => {
      actionObj[optionKey] = (stateData: any, params: any) => {   
      const optionValue = dictValue.options[optionKey];
      var details =  stateData && optionValue?.details ? optionValue?.details(stateData) :{}; 
      var subscriber = stateData?._subscriber;

        setTimeout(() => {  
          try {
          const state = EpiContext.getStore().getState();
          const loginData = state.authentication.loginData;
          details = {...details, _subscriber: subscriber || loginData.userDetails.contactNumber};
            const reportParams = getReportParams();
            reportParams.area = dictValue.area;
            reportParams.subArea = dictValue.subArea;
            reportParams.channel = 'WebsiteBusiness';
            reportParams.actionType = optionValue.actionType;
            reportParams.messageText = optionValue.messageText;
            reportParams.status ='Completed';
            reportParams.customerName = loginData.userDetails.firstName + ' ' + loginData.userDetails.lastName;
            reportParams.email = loginData.userDetails.email;
            reportParams.idNumber = loginData.userDetails.IDNumber;
            reportParams.param1 = params?.param1 ||"";
            reportParams.param2 = params?.param2 ||"";
            reportParams.param3 = params?.param3 ||"";
            reportParams.param4 = params?.param4 ||"";
            reportParams.param5 = params?.param5 ||"";
            reportParams.param6 = params?.param6 ||"";
            reportParams.param7 = params?.param7 ||"";
            reportParams.param8 = params?.param8 ||"";
            reportParams.param9 = params?.param9 ||"";
            reportParams.param10 =params?.param10 ||"";
            reportParams.businessDetails = details;
      
            report(reportParams);
          } catch (error) {
            console.error('Error in selfServiceDwh:', error);
          }
        }, 0);
      };
    });
  
  return actionObj;
};

const abroadPackageDetails = (stateData: any) => {
  let price = stateData?.selectedAbroadPackage?.price?.toString();
  if(!price || price === '0') {
    price = 'ללא עלות';
  }else{
    price = price + '₪';
  }

  return {
    'שם חבילה':  stateData?.selectedAbroadPackage?.labelEpi,
    'עלות': price,
    'תאריכי חבילה': stateData?.dates?.selectedEndDate + ' - ' + stateData?.dates?.selectedStartDate ,
  };
};
export const selfServiceDwh = {
  AbroadPackage: createDwhAction({
    area: 'SelfCare',
    subArea: 'Cellcom Abroad',
    options: {
      Purchase: {
        actionType: 'Purchase abroad package',
        messageText: 'Purchase  abroad package succeeded',
        details :abroadPackageDetails,
      },
      Remove: {
        actionType: 'Remove abroad package',
        messageText: 'Remove abroad package succeeded',    
        details :abroadPackageDetails,
      },
      Update: {
        actionType: 'Update abroad package',
        messageText: 'Update abroad package succeeded',
      },

    },
  }),


  TransferOrganizationAccount: createDwhAction({
    area: 'SelfCare',
    subArea: 'NewOrder',
    options: {
      UpdateClientName: {
        actionType: 'Update Subscriber Name',
        messageText: 'Update Subscriber Name succeeded',
        details: (stateData: any) => {
          return {
            'שם שעודכן': stateData?.name,
          };
        },
      },
      AddIMEI: {
        actionType: 'Add IMEI',
        messageText: 'Add IMEI succeeded',
        details: (stateData: any) => {
          return {
            'מספר IMEI': stateData?.imei,
          };
        },
      },
      BlockTransfer: {
        actionType: 'Block Transfer',
        messageText: 'Block Transfer succeeded',
      },
    },
  }),

  UpgradeEsim: createDwhAction({
    area: 'SelfCare',
    subArea: 'SIMtoESIM',
    options: {
      Upgrade: {
        actionType: 'Service Purchase',
        messageText: 'Upgrade to Esim succeeded',
      },
    },
  }),

  DeptPayment: createDwhAction({
    area: 'SelfCare',
    subArea: 'Business Debt Payment',
    options: {
      UpdatePayment: {
        actionType: 'Finished Business Debt Payment', 
        messageText: 'Debt Payment succeeded',
        details: (stateData: any) => {
          return {
            "מס' לקוח": stateData?.account,
            'גובה החוב': stateData?.amount,
            'סוג אמצעי תשלום':  "כרטיס אשראי" ,
            'תוקף כ.א': stateData?.cardMonth + '/' + stateData?.cardYear,
            'טוקן כ.א': stateData?.CCToken,
            "מס' אמסכתא": stateData?.receptionNo,
          };
        },
      },
    },
  }),
};




